<ul class="stepper">
    <li>
        <a class="active" href="javascript:void(0);">1</a>
    </li>
    <li>
        <a class="active" href="javascript:void(0);">2</a>
    </li>
    <li class="no-number">
        <a class="active" href="javascript:void(0);"></a>
    </li>
    <li class="no-number">
        <a class="active" href="javascript:void(0);"></a>
    </li>
    <li class="no-number">
        <a class="active" href="javascript:void(0);"></a>
    </li>
    <li>
        <a href="javascript:void(0);">3</a>
    </li>
    <li>
        <a href="javascript:void(0);">4</a>
    </li>
    <li>
        <a href="javascript:void(0);">5</a>
    </li>
    <li>
        <a href="javascript:void(0);">6</a>
    </li>
</ul>